var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13885,
    height: 10756,
    viewBox: "0 0 13885 10756",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_719)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13885,
    height: 10756,
    fill: "#C4D5D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5708.66 15296C9631.54 16306.5 11480 18267 8792 20767.1C4756.18 18578.2 -2588.87 17507.1 -4316.9 15641.6C-7852.01 11831.8 -552.137 9921.83 2870.03 10540.3C2327.91 10916.2 -634.962 13673 5708.66 15296Z",
    fill: "#E1CDD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5986.57 14582.5C10270.9 15013 13004.1 16652.1 11633.7 19439.2C6679.29 17885 -929.298 17870.8 -3500.63 16310.5C-8767.53 13121.2 -2642.26 10263.4 964.378 10384.6C621.785 10821.2 -914.238 13897.3 5986.57 14582.5Z",
    fill: "#EFE5EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.51 9085.16C-2502.61 8074.61 -4351.11 6112.11 -1663.07 3612C2372.76 5800.86 9717.81 6874.07 11445.8 8737.53C14980.9 12547.3 7681.07 14457.3 4258.9 13838.8C4797.26 13464.9 7763.9 10706.1 1416.51 9085.16Z",
    fill: "#FFD2C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.29 9796.47C-3141.95 9374.06 -5875.17 7726.86 -4485.97 4945.81C468.453 6500.04 8020.57 6548.55 10648.4 8074.49C15896.4 11257.7 9771.18 14115.6 6164.54 14002.4C6507.13 13557.8 8039.39 10481.6 1127.29 9796.47Z",
    fill: "#F9D0C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8106.65 7191.23C5121.19 6524.26 716.424 6219.07 -2863.86 5380.31C-3013.68 5900.6 -2919.22 6432.75 -2589.04 6928.48C1311.26 7041.67 5407.32 6768.82 8106.65 7191.23Z",
    fill: "#E9B7AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.89 10522.1C-3145.82 10706 -6583.04 9495.39 -6583.04 6611.27C-1048.85 7419.71 6307.49 6378.84 9541.42 7528.85C16152.3 9881.43 11612 13493.1 8069.4 13877.2C8186.11 13408.3 8186.11 10223 1179.89 10522.1Z",
    fill: "#FEDBAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5949.76 13844.9C10275.5 13658.9 13712.7 14869.6 13712.7 17755.7C8178.49 16947.3 822.152 17988.1 -2411.78 16836.1C-9022.7 14485.6 -4489.93 10875.8 -947.286 10491.8C-1045.17 10960.7 -1060.23 14144 5949.76 13844.9Z",
    fill: "#89AAAD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13885,
    height: 10756,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.ddc758bd3b824a05c95ddc63587cd0af.svg";
export { ForwardRef as ReactComponent };